module.exports = __webpack_public_path__ + "static/scale-model-of-san-mateo-county-history-museum-in-san-mateo-california-2d039e0a1389c71941ecb6d52853b789.png";